import {ThemeIconKey} from 'platform/foundation';

import {isEmpty, isNil} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

/** Already formatted values (with units), as the preview shows them. */
export interface SpecificationValues {
  year: string | Nullish;
  power: string | Nullish;
  driveType: string | Nullish;
  mileage: string | Nullish;
  transmission: string | Nullish;
  fuelType: string | Nullish;
  carStyle: string | Nullish;
}

type SpecificationKey = keyof SpecificationValues;

/** The order and icons of the Price Report vehicle header, so both products read the same. */
const SPECIFICATIONS: Array<{key: SpecificationKey; icon: ThemeIconKey; labelKey: string}> = [
  {key: 'year', icon: 'automotive/calendar', labelKey: 'entity.vehicle.labels.year'},
  {
    key: 'power',
    icon: 'automotive/engine',
    labelKey: 'entity.sourcing.vehiclePreview.labels.power',
  },
  {
    key: 'driveType',
    icon: 'automotive/differential',
    labelKey: 'entity.sourcing.vehiclePreview.labels.differential',
  },
  {
    key: 'mileage',
    icon: 'automotive/mileage',
    labelKey: 'entity.sourcing.vehiclePreview.labels.mileage',
  },
  {
    key: 'transmission',
    icon: 'automotive/transmission',
    labelKey: 'entity.sourcing.vehiclePreview.labels.transmission',
  },
  {
    key: 'fuelType',
    icon: 'automotive/fuel_type',
    labelKey: 'entity.sourcing.vehiclePreview.labels.fuel',
  },
  {
    key: 'carStyle',
    icon: 'automotive/car',
    labelKey: 'entity.sourcing.vehiclePreview.labels.bodyType',
  },
];

/** Specification chips of a listing; values the ad does not state are left out. */
export const buildSpecificationItems = (values: SpecificationValues) =>
  SPECIFICATIONS.flatMap((specification) => {
    const value = values[specification.key];

    // ramda's isNil narrows the value to a string; ramda-adjunct's isNilOrEmpty does not.
    if (isNil(value) || isEmpty(value)) {
      return [];
    }

    return [
      {
        key: specification.key,
        icon: specification.icon,
        label: i18n.t(specification.labelKey),
        value,
      },
    ];
  });
